import gql from 'graphql-tag';

export const queryForEmailGroups = gql`
  query queryForEmailGroups(
    $id: String
    $name: String
    $query: DTWithBUSortOrQuery
    $sort: DTWithBUSortOrQuery
  ) {
    queryForEmailGroups(id: $id, name: $name, query: $query, sort: $sort) {
      createdAt
      createdBy
      deletedAt
      enabled
      id
      name
      updatedAt
      updater
      version
      EmailGroupMembers {
        address
        createdAt
        createdBy
        deletedAt
        id
        updatedAt
        updater
        version
      }
      businessUnits {
        name
      }
      businessUnitString
    }
  }
`;
